import { useState } from "react";
import { Edit2, Trash2, Phone, Briefcase } from "lucide-react";
import DeleteStaffModal from "./DeleteStaffModal";
import useAxiosAdmin from "../../../lib/axiosAdmin";
import { useDispatch } from "react-redux";
import { SET_SHOULD_UPDATE_ADMIN_USERS } from "../../../../../redux/action/admin/users/type";

const StaffListRow = ({ item, onDelete, onEdit }) => {
  const axiosAdmin = useAxiosAdmin();
  const [deleteId, setDeleteId] = useState(null);
  const dispatch = useDispatch()

  const handleDelete = async () => {
    await axiosAdmin.delete(`/api/admin/staff/${deleteId}`);
    setDeleteId(null);
    onDelete();

    dispatch({
      type: SET_SHOULD_UPDATE_ADMIN_USERS,
      payload: true,
    })    

  };

  const getAvatarColor = (name) => {
    const colors = [
      "from-purple-500 to-purple-600",
      "from-blue-500 to-blue-600",
      "from-pink-500 to-pink-600",
      "from-indigo-500 to-indigo-600",
      "from-violet-500 to-violet-600",
      "from-fuchsia-500 to-fuchsia-600",
    ];
    const index = name?.charCodeAt(0) % colors.length || 0;
    return colors[index];
  };

  const getInitial = (firstName, lastName) => {
    return (firstName?.[0] || "") + (lastName?.[0] || "");
  };

  const { firstName, lastName, displayName, phone } = item.information || {};
  const servicesCount = item.services?.length || 0;
  const initial = getInitial(firstName);
  const avatarColor = getAvatarColor(firstName);

  return (
    <>
      <tr className="group hover:bg-purple-50/30 transition-colors duration-200">
        {/* نام کامل با آواتار */}
        <td className="px-3 sm:px-6 py-3 sm:py-4 whitespace-nowrap">
          <div className="flex items-center gap-2 sm:gap-3">
            <div
              className={`w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-br ${avatarColor} flex items-center justify-center text-white font-bold text-xs sm:text-sm shadow-md flex-shrink-0`}
            >
              {initial}
            </div>
            <div className="min-w-0 flex-1">
      
              <div className="text-slate-900 font-medium text-sm truncate">
                {firstName} {lastName}
              </div>
              
              <span className="text-xs text-slate-500 font-medium">{displayName}</span>

              {/* نمایش شماره تماس در موبایل */}
              <div className="md:hidden flex items-center gap-1.5 text-slate-600 text-xs mt-1">
                <Phone className="w-3 h-3 text-slate-400 flex-shrink-0" />
                <span className="font-mono truncate">{phone}</span>
              </div>
              {/* نمایش تعداد خدمات در موبایل و تبلت */}
              <div className="lg:hidden mt-1.5">
                <span className="hidden items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-700">
                  <Briefcase className="w-3 h-3" />
                  {servicesCount}
                </span>
              </div>
            </div>
          </div>
        </td>

        {/* شماره تماس - فقط دسکتاپ */}
        <td className="hidden md:table-cell px-3 sm:px-6 py-3 sm:py-4 whitespace-nowrap">
          <div className="flex items-center gap-2 text-slate-600 text-sm">
            <Phone className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />
            <span className="font-mono">{phone}</span>
          </div>
        </td>

        {/* تعداد خدمات - فقط دسکتاپ بزرگ */}
        <td className="hidden lg:table-cell px-3 sm:px-6 py-3 sm:py-4 whitespace-nowrap">
          <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-700">
            {servicesCount} خدمت
          </span>
        </td>

        {/* دکمه‌های عملیات */}
        <td className="px-3 sm:px-6 py-3 sm:py-4 whitespace-nowrap">
          <div className="flex items-center justify-end gap-1.5 sm:gap-2">
            <button
              onClick={() => onEdit(item)}
              className="group/btn flex items-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg bg-blue-50 text-blue-600 hover:bg-blue-100 hover:shadow-md hover:shadow-blue-500/10 transition-all duration-200"
              title="ویرایش کارمند"
            >
              <Edit2 className="w-3.5 h-3.5 group-hover/btn:scale-110 transition-transform flex-shrink-0" />
              <span className="hidden sm:inline text-xs font-medium">ویرایش</span>
            </button>

            <button
              onClick={() => setDeleteId(item._id)}
              className="group/btn flex items-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg bg-red-50 text-red-600 hover:bg-red-100 hover:shadow-md hover:shadow-red-500/10 transition-all duration-200"
              title="حذف کارمند"
            >
              <Trash2 className="w-3.5 h-3.5 group-hover/btn:scale-110 transition-transform flex-shrink-0" />
              <span className="hidden sm:inline text-xs font-medium">حذف</span>
            </button>
          </div>
        </td>
      </tr>

      {deleteId && (
        <DeleteStaffModal
          onConfirm={handleDelete}
          onCancel={() => setDeleteId(null)}
        />
      )}
    </>
  );
};

export default StaffListRow;